import { render, staticRenderFns } from "./ModalCriarPastas.vue?vue&type=template&id=0733ce86&"
import script from "./ModalCriarPastas.vue?vue&type=script&lang=js&"
export * from "./ModalCriarPastas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports